import React from 'react'
import { Skeleton, useContainerWidth } from '@fs/zion-ui'

export default function LastEditedIndicatorSkeleton(): JSX.Element {
  const atSize = useContainerWidth()
  return <Skeleton.Chip data-testid="banner-last-edited-skeleton" width={atSize({ default: 120, xl: 180 })} />
}
